const detectLocale = require('./src/components/i18n').detectLocale;

if (typeof document !== 'undefined' && document.location.pathname == '/') {
    var locale = detectLocale() == 'fr' ? 'fr' : 'en';
    document.location.pathname = `/${locale}`;
}
